import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/base-components';
import { cx, FOCUS_RING } from '../components/styles';
import { ANCHORS, CONTAINER, CTA_MICROCOPY } from './landingConfig';
import { ProductMock } from './ProductMock';
import { useLandingCtas } from './useLandingCtas';

/**
 * Section 2. Renders immediately — never behind an IntersectionObserver, so it
 * cannot delay LCP.
 *
 * The H1 is one sentence, ten words, grade-5 reading level, and states the
 * product's actual job without claiming a number. Do not put a price here.
 */
export const LandingHero: React.FC = () => {
  const { primary, signedIn } = useLandingCtas();
  return (
  <section className={cx(CONTAINER, 'pt-12 pb-20 lg:pb-28')}>
    <div className="grid items-center gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <p className="text-xs uppercase tracking-[0.16em] text-[#60a5fa]">FOR TICKET SELLERS</p>
        <h1 className="mt-4 text-4xl font-bold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[56px]">
          One place to run every ticket account you own.
        </h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/60">
          Connect DICE, AXS and TAO once. Then run waitlists, transfers and listings from a
          single dashboard.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <Link to={primary.to} className={cx('rounded-lg', FOCUS_RING)}>
            <Button size="lg" whitespace="nowrap">
              {primary.label}
            </Button>
          </Link>
          <a href={`#${ANCHORS.how}`} className={cx('rounded-lg', FOCUS_RING)}>
            <Button variant="secondary" size="lg" whitespace="nowrap">
              See how it works
            </Button>
          </a>
        </div>

        {!signedIn && <p className="mt-4 text-xs text-white/40">{CTA_MICROCOPY}</p>}
      </div>

      <div className="lg:col-span-7">
        <ProductMock />
      </div>
    </div>
  </section>
  );
};
